import { useState, useEffect } from 'react';
import MerchantPaymentsService from '../../../services/MerchantPaymentsService';

export const useStaticQr = storeId => {
  const [qrData, setQrData] = useState({
    code: '',
    url: '',
    hasQr: false,
    loading: false,
    error: null,
  });

  useEffect(() => {
    if (!storeId) {
      setQrData({
        code: '',
        url: '',
        hasQr: false,
        loading: false,
        error: null,
      });
      return;
    }

    const fetchStaticQr = async () => {
      setQrData(prev => ({ ...prev, loading: true, error: null }));

      try {
        const response =
          await MerchantPaymentsService().getStaticCodeByStore(storeId);

        if (response && response.url) {
          setQrData({
            code: response.code || '',
            url: response.url,
            hasQr: true,
            loading: false,
            error: null,
          });
        } else {
          setQrData({
            code: '',
            url: '',
            hasQr: false,
            loading: false,
            error: 'No hay QR estático disponible para esta tienda',
          });
        }
      } catch (error) {
        console.error('Error fetching static QR:', error);
        setQrData({
          code: '',
          url: '',
          hasQr: false,
          loading: false,
          error: 'Error al obtener el QR estático',
        });
      }
    };

    fetchStaticQr();
  }, [storeId]);

  return qrData;
};
